import { z } from '@harvestiq/zod';

export const sendLgmCampaignEmailsMessageSchema = z.object({
  campaignId: z.string(),
  orgId: z.string(),
  // This should be used only for manual queuing scripts. Do not actively use it.
  salesEffectiveDate: z.string().optional(),
});

export type SendLgmCampaignEmailsMessage = z.infer<
  typeof sendLgmCampaignEmailsMessageSchema
>;
